/**
 * Inline SVG logo for LJMG.
 * `variant="light"` → white letters on dark backgrounds (header / footer)
 * `variant="dark"`  → black letters on light backgrounds (reserved for future use)
 * Both keep the red accent underline.
 */
export const Logo = ({ variant = "light", className = "", ...rest }) => {
  const textColor = variant === "light" ? "#FFFFFF" : "#0A0A0A";

  return (
    <svg
      viewBox="0 0 220 60"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="LJMG"
      className={className}
      {...rest}
    >
      <text
        x="0"
        y="42"
        fontFamily="'Playfair Display', Georgia, serif"
        fontWeight="700"
        fontSize="44"
        letterSpacing="2"
        fill={textColor}
      >
        LJMG
      </text>
      <rect x="0" y="52" width="148" height="3" fill="#E10600" />
    </svg>
  );
};
